import { Sector } from 'recharts'

import { analyticsNumberFormatter } from '../utils/parser.js'

interface PieChartToolTipHOCProps {
  label: string
}
export const PieChartToolTipHOC = ({ label }: PieChartToolTipHOCProps) => {
  return props => <PieChartToolTip {...props} label={label} />
}

interface PieChartToolTipProps {
  cx: number
  cy: number
  innerRadius: number
  outerRadius: number
  startAngle: number
  endAngle: number
  fill: string
  value: number
  label: string
}
const PieChartToolTip = ({
  cx,
  cy,
  innerRadius,
  outerRadius,
  startAngle,
  endAngle,
  fill,
  value,
  label,
}: PieChartToolTipProps) => {
  const fontSize = Math.min(innerRadius / 2.5, 15)

  return (
    <g>
      <text x={cx} y={cy} fontSize={fontSize} textAnchor="middle" fill={fill}>
        {label}
      </text>
      <text
        x={cx}
        y={cy + fontSize * 1.4}
        fontSize={fontSize}
        textAnchor="middle"
        fill={fill}
      >
        {analyticsNumberFormatter(value)}
      </text>
      <Sector
        cx={cx}
        cy={cy}
        innerRadius={innerRadius}
        outerRadius={outerRadius}
        startAngle={startAngle}
        endAngle={endAngle}
        fill={fill}
      />
      <Sector
        cx={cx}
        cy={cy}
        startAngle={startAngle}
        endAngle={endAngle}
        innerRadius={outerRadius + 2}
        outerRadius={outerRadius + 5}
        fill={fill}
      />
    </g>
  )
}
